import React from 'react';
import { Toggle as KToggle } from '@ui-kitten/components';
const Kitten = (props) => {
    const { text, checked, onPress, ...rest } = props;
    return (<KToggle text={text} checked={checked} onChange={onPress} {...rest}/>);
};
export default {
    Kitten,
};
//# sourceMappingURL=Toggle.js.map